import { inject } from '@angular/core';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { catchError, forkJoin, of } from 'rxjs';

export const initialDataResolver = () => {
    const navigationService = inject(NavigationService);

    // Fork join multiple API endpoint calls to wait all of them to finish.
    // Each call is wrapped with catchError so a single API failure (e.g. 403 for
    // limited roles like PHOTOGRAPHER) does not cancel the entire navigation.
    //
    // PFL-1680: notifications are NOT blocked on here anymore. NotificationsService's
    // constructor already fetches on user$ (with getAll()'s own in-flight guard), and
    // the bell is non-critical to page render — forcing navigation to wait on it just
    // produced a second, redundant GET /notifications every time this resolver ran
    // (once per shell-root entry: admin-shell and photoqa-portal each wire it).
    return forkJoin([navigationService.get().pipe(catchError(() => of(null)))]);
};
